var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import { globalConfig } from '../config-provider';
import { VisibilityIcon, VisibilityOffIcon } from '../icon';
const spaceOfStartAndEndReg = /(^\s+\S*)|(\S+\s+$)/;
export const handleFilterSpace = (e, onChange, onBlur) => {
    const { value } = e.target;
    if (spaceOfStartAndEndReg.test(value)) {
        e.target.value = value === null || value === void 0 ? void 0 : value.trim();
        onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, e));
    }
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(Object.assign({}, e));
};
export function WithTrim(Component, comType, isRef) {
    class TrimedComponent extends React.Component {
        constructor() {
            super(...arguments);
            this.handleBlur = (e) => {
                const { autoTrim = true, onChange, onBlur } = this.props;
                if (autoTrim) {
                    handleFilterSpace(e, onChange, onBlur);
                }
                else {
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
                }
            };
        }
        render() {
            const _a = this.props, { forwardedRef, className, onBlur, autoTrim, prefixCls: customizePrefixCls } = _a, rest = __rest(_a, ["forwardedRef", "className", "onBlur", "autoTrim", "prefixCls"]);
            const { disabled } = rest;
            const { getPrefixCls } = globalConfig();
            const prefixCls = getPrefixCls(comType, customizePrefixCls);
            return (React.createElement(Component, Object.assign({ ref: forwardedRef, className: classNames(prefixCls, className), onBlur: this.handleBlur, iconRender: visible => visible ? React.createElement(VisibilityIcon, { disabled: disabled }) : React.createElement(VisibilityOffIcon, { disabled: disabled }) }, rest)));
        }
    }
    if (isRef) {
        return Component ? React.forwardRef((props, ref) => React.createElement(TrimedComponent, Object.assign({ forwardedRef: ref }, props))) : null;
    }
    return Component ? TrimedComponent : null;
}
